import React from 'react';
import { useTheme } from '../hooks/useTheme';
const ThemeToggle: React.FC = () => {
  const { toggleTheme } = useTheme();
  return (
    <span className="theme-toggle">
      <div className="switch" onClick={toggleTheme}>
        <div className="btn"></div>
      </div>
    </span>
  );
};
export default ThemeToggle; 